@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../constants/spacing.module.less';
@import '../../../../../../../../constants/screen-width-breakpoints.module.less';

.ftu-csv-upload {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  padding: @space-32;
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  background-color: var(--white);
  max-width: 960px;
  margin: 0 auto;

  @media @mobile, @ultramobile {
    padding: @space-16;
  }
}

.upload-header {
  display: flex;
  align-items: center;
  gap: @space-12;
  padding-bottom: @space-16;
  border-bottom: 1px solid var(--grey-300);
  margin-bottom: @space-16;
}

.content-layout {
  display: flex;
  gap: @space-32;
  align-items: flex-start;

  @media @mobile, @ultramobile {
    flex-direction: column;
    gap: @space-16;
  }
}

.left-section {
  flex: 1;
}

.right-section {
  flex: 1;
}

.header-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: var(--grey-700);
}

.header-text {
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: var(--grey-900);
}

.checklist-section {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  padding-left: @space-4;
}

.checklist-item {
  display: flex;
  align-items: flex-start;
  gap: @space-12;
}

.check-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
  color: var(--green-500);
}

.checklist-content {
  display: flex;
  align-items: center;
  gap: @space-4;
  flex-wrap: wrap;
}

.checklist-content-full {
  display: flex;
  flex-direction: column;
  gap: @space-8;
  flex: 1;
}

.checklist-label {
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin-bottom: @space-8;
}

.download-link {
  color: var(--blue-600);
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;

  &:hover {
    color: var(--blue-700);
  }
}

.store-dropdown-wrapper {
  width: 100%;
  max-width: 400px;
}

.drag-drop-section {
  display: flex;
  flex-direction: column;
}

.drop-area {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: @space-32;
  border: 2px dashed var(--grey-300);
  border-radius: 8px;
  background-color: var(--gray-F9FAFB);
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: var(--blue-500);
    background-color: var(--blue-50);
  }

  &.uploaded {
    border-color: var(--green-400);
    background-color: var(--green-50);
  }

  &.error {
    border-color: var(--red-400);
    background-color: var(--red-50);
  }
}

.drag-drop-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: @space-12;
  text-align: center;
}

.upload-icon {
  width: 48px;
  height: 48px;
  font-size: 48px;
  color: var(--grey-500);
}

.file-icon {
  width: 48px;
  height: 48px;
  font-size: 48px;
  color: var(--green-600);
}

.error-icon {
  width: 48px;
  height: 48px;
  font-size: 48px;
  color: var(--red-600);
}

.drag-drop-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-700);
  font-weight: 500;
}

.file-name {
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-900);
  font-weight: 600;
}

.error-text {
  font-size: 14px;
  line-height: 20px;
  color: var(--red-700);
  font-weight: 500;
}

.or-text {
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-500);
  margin: @space-4 0;
}

.select-file-button,
.replace-file-button {
  min-width: 140px;
}

.action-section {
  display: flex;
  justify-content: flex-end;
  padding-top: @space-8;
}
